import { $apiDelete, $apiGet, $apiPost, $apiPut } from '~/utils/request'
import type { LawFirmEmployee } from '~/models'

export const GetAll = () => $apiGet<LawFirmEmployee[]>(`/v1/lawFirmEmployee/all`)

export const GetByNameKeyword = (query: { nameKeyword: string }, isLoading?) => $apiGet<LawFirmEmployee[]>(`/v1/lawFirmEmployee/byNameKeyword`, query, isLoading)

export const GetLawyersByNameKeyword = (query: { nameKeyword: string, caseSysNumber?: string }, isLoading?) => $apiGet<LawFirmEmployee[]>(`/v1/lawFirmEmployee/lawyersByNameKeyword`, query, isLoading)

export const GetCommonsByNameKeyword = (query: { nameKeyword: string, caseSysNumber?: string }, isLoading?) => $apiGet<LawFirmEmployee[]>(`/v1/lawFirmEmployee/commonsByNameKeyword`, query, isLoading)
